export default __webpack_public_path__ + "static/media/kvitanciyaPlatka.68b9e712.68b9e712.pdf";